module.exports = __webpack_public_path__ + "img/product_4.46bd3f35.jpg";